import { useContext } from "react";
import CartContext from "../../../store/cart-context";
import CryptoItemForm from "./CryptoItemForm";
import classes from "./CryptoItem.module.css";

const CryptoItem = (props) => {
  console.log("*** CryptoItem ***");
  const { id, naam, aankoophoeveelheid, aankoopprijs, aankoopdatum } = props;
  console.log("id: " + id);
  console.log("naam: " + naam);
  console.log("aankoophoeveelheid: " + aankoophoeveelheid);
  console.log("aankoopprijs: " + aankoopprijs);
  console.log("aankoopdatum: " + aankoopdatum);

  //const aankoopdatum2 = new Date(Date.parse(props.aankoopdatum));

  const cartCtx = useContext(CartContext);
  const buyprice = `€${props.aankoopprijs}`;

/*  
  const day = aankoopdatum2.toLocaleString("nl-NL", { day: "2-digit" });
  let month = (aankoopdatum2.getMonth() + 1).toString();
  month = month.padStart(2, "0");
  const year = aankoopdatum2.getFullYear();
  const datum = day + "-" + month + "-" + year;
*/

  /*
  const hours = aankoopdatum2.getHours();
  const minutes = aankoopdatum2.getMinutes();
  const seconds = aankoopdatum2.getSeconds();
  const tijd = hours + ":" + minutes + ":" + seconds;
*/

  const addToCartHandler = (amount) => {
    console.log(amount);
    // addItem verwacht als input item

    cartCtx.addItem({
      id: props.id,
      naam: props.naam,
      aankoophoeveelheid: amount,
      aankoopprijs: props.aankoopprijs, // Niet de geformatteerde pice
    });
  };

  // <div>Tijdstip: {tijd}</div>

  // key={props.id} en niet key={props.key} want key is GEEN prop

  /*
        <div className={classes.description}>
          Aankoophoeveelheid: {props.aankoophoeveelheid}
        </div>
        <div>Aankoopdatum: {datum}</div>
*/
  return (
    <li key={props.id} className={classes.meal}>
      <div>
        <h3 className={classes.name}>{props.naam}</h3>
        <div className={classes.price}>{buyprice}</div>
      </div>
      <div>
        <CryptoItemForm id={props.id} onAddToCart={addToCartHandler} />
      </div>
    </li>
  );
};

export default CryptoItem;
